import React from 'react';
import { Link } from 'react-router-dom';
import { KitImage } from './ui/KitImage';

export default function Hero() {
  return (
    <section className="hbk-hero" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-[1.15fr_0.85fr] gap-8 lg:gap-12 items-center">
        <div className="hbk-hero-copy">
          <p className="section-marker" data-testid="hero-brand">HomeBloodKit · Integrated Wellness</p>
          <h1 className="hbk-hero-heading" data-testid="hero-heading">At-Home Blood Testing. <span>Personalized Beyond the Lab.</span></h1>
          <p className="hbk-hero-subtitle" data-testid="hero-subtitle"><span>The right panel.</span>{' '}<span>Your data.</span>{' '}<span>One personalized plan.</span></p>
          <p className="hbk-hero-description" data-testid="hero-description">
            <span>We help match you with the right at-home blood panel,</span>{' '}
            <span>then bring together your lab results, health history, goals, wearable data, and DNA insights when available</span>{' '}
            <span>to build a personalized wellness protocol designed around you.</span>
          </p>
          <div className="hbk-hero-actions">
            <a href="#shop" className="btn-cta hbk-short-cta" data-testid="hero-shop-cta">VIEW ALL PANELS</a>
            <Link to="/order" className="btn-cta-ghost hbk-short-cta" data-testid="hero-customize-cta">FIND MY PANEL</Link>
          </div>
          <p className="hbk-hero-note" data-testid="hero-workflow-note">Team-reviewed intake. Wearable and DNA data are optional.</p>
        </div>
        <div className="hbk-hero-visual" data-testid="hero-visual-card">
          <div className="aspect-[59/41]" data-testid="hero-kit-image-frame"><KitImage testId="hero-kit-image" loading="eager" /></div>
          <p className="text-sm text-[#2a3950] mt-3" data-testid="hero-kit-caption">RedDrop One · At-home blood collection</p>
        </div>
      </div>
    </section>
  );
}